










































import CatCard from "@/components/CatCard.vue";
import Vue from "vue";
import { Cat } from "@/common/types";

export default Vue.extend({
  metaInfo: {
    title: "Home",
    titleTemplate: "%s - Catcyclopedia",
    htmlAttrs: {
      lang: "en"
    },
    meta: [
      {
        vmid: "description",
        name: "description",
        content: "Cat database with images and information about various breeds"
      }
    ]
  },

  name: "home",

  components: {
    "cat-card": CatCard
  },
  computed: {
    cats(): Array<Cat> {
      let catArray: Array<Cat> = this.$store.state.cats;

      switch (this.selectedCategory) {
        case "intelligence":
          catArray = catArray.filter(
            (cat: Cat): boolean => cat.intelligence === 3
          );
          break;

        case "dog_friendly":
          catArray = catArray.filter(
            (cat: Cat): boolean => cat.dog_friendly === 2
          );
          break;

        case "affection_level":
          catArray = catArray.filter(
            (cat: Cat): boolean => cat.affection_level === 3
          );
          break;

        case "indoor":
          catArray = catArray.filter((cat: Cat): boolean => !cat.indoor);
          break;

        case "energy_level":
          catArray = catArray.filter(
            (cat: Cat): boolean => cat.energy_level === 1
          );
          break;
      }

      if (this.selectedSortingMethod === "Z-A") {
        catArray = catArray
          .slice()
          .sort((aCat: Cat, bCat: Cat) => (aCat.name > bCat.name ? -1 : 1));
      }

      return catArray.slice(0, 10);
    }
  },

  data(): {
    selectedCategory: string;
    selectedSortingMethod: string;
    categories: string;
    sortingOptions: string;
  } {
    return {
      selectedSortingMethod: "A-Z",
      selectedCategory: "indoor",
      categories: "",
      sortingOptions: ""
    };
  }
});
